$(() => {
	$('.sustain__process').on('click', '.sustain__process-icon-wrap', function() {
		const clicked = $(this).data('step'),
				nav = $(this);
		let details;
		if ( nav.hasClass('active') ) {
			nav.removeClass('active');
		} else {
			$('.sustain__process-icon-wrap').removeClass('active');
			nav.addClass('active');
		}
		$('.sustain__process-details').each(function() {
			details = $(this);
			if ( details.data('details') === clicked ) {
				details.slideToggle(400, function() {
					$(this).toggleClass('active');
				});
			} else {
				details.removeClass('active');
				details.slideUp();
			}
		});
	});

	$('.sustain__chart').on('click', '.sustain__chart-icon', function() {
		const clicked = $(this).data('step');
		let details;
		$('.sustain__distill-details').each(function() {
			details = $(this);
			if ( details.data('details') === clicked ) {
				details.lightbox_me({
					centered: true
				});
			}
		});
	});
	$('.sustain__distill-details').on('click', '.sustain__distill-close', function() {
		$(this).trigger('close');
	});
});

/*
$(document).ready(function() {
	var sg = new sustainGraphic();
});

var info = 
[
	{
		"title":"Molasses",
		"icon":"molasses",
		"linkX":256,
		"linkY":206,
		"level":1,
		"text":"Historically, molasses and rum began as recycled products, the biproduct of granulated sugar production. The heat applied to cane juice releases some of the sugars as crystals while caramelizing the remaining sugars in the molasses. This process also gives molasses its golden-brown color."
	},
	{
		"title":"Fermentation",
		"icon":"fermentation",
		"linkX":416,
		"linkY":206,
		"level":1,
		"text":"While diluted molasses ferments, it releases CO2. Instead of just releasing it into the air, we capture it and make it available to local soft drink producers. This decreases our net carbon footprint while helping the soda in Puerto Rico stay bubbly."
	},
	{
		"title":"Distillation",
		"icon":"distillation",
		"linkX":573,
		"linkY":206,
		"level":1,
		"text":"Distillation is an energy-intensive process in which steam is forced through columns in order to cull the alcohol from the fermented molasses “beer”. Once alcohol is removed, what remains is a large volume of wastewater. The wastewater is laden with organic material—basically everything from the molasses “beer” except the alcohol. "
	},
	{
		"title":"Anaerobic Digesters",
		"icon":"anaerobic",
		"linkX":573,
		"linkY":428,
		"level":1,
		"text":"The first step in waste treatment is performed in a sealed chamber. This process removes about 70% of the organic material in the wastewater. Specialized bacteria digest the raw waste in an oxygen-deprived environment. As they do their work, the bacteria release volatile compounds that are captured and concentrated into valuable Biogas."
	},
	{
		"title":"Biogas",
		"icon":"biogas",
		"linkX":689,
		"linkY":554,
		"level":2,
		"text":"The Biogas from our process powers the boilers that make the steam necessary for distillation. Using Biogas, we manage to offset 50 – 70% of our annual oil usage. When one factors in the energy required for crude oil extraction and delivery, we’ve eliminated about 2 million gallons of crude oil consumption per year."
	},
	{
		"title":"Solids Clarifier",
		"icon":"clarifier",
		"linkX":573,
		"linkY":626,
		"level":2,
		"text":"Most of the remaining organic and inorganic solids are removed and separated from the wastewater."
	},
	{
		"title":"Wood Chips",
		"icon":"woodchips",
		"linkX":373,
		"linkY":767,
		"level":2,
		"text":"We make our own woodchips by grinding down used shipping pallets that we obtain at zero cost."
	},
	{
		"title":"Compost",
		"icon":"compost",
		"linkX":494,
		"linkY":885,
		"level":3,
		"text":"The bio-solids recuperated through the process are dewatered and mixed with wood chips to create industrial compost to be used as fertilizer or soil additive."
	},
	{
		"title":"Fertilizer Mulch",
		"icon":"fertilizer",
		"linkX":494,
		"linkY":1090,
		"level":3,
		"text":"We use our composted organic solids to produce rich, soil-invigorating mulch that’s used by landscapers and gardeners. We add natural colors for aesthetic purposes and market the product all over Puerto Rico."
	},
	{
		"title":"Aerobic Digesters",
		"icon":"aerobic",
		"linkX":652,
		"linkY":885,
		"level":3,
		"text":"In this process, a large volume of wastewater is circulated and aerated in an open system, bombarding the remaining organics with oxygen. This allows the materials to both oxidize and be digested by oxygen-dependent bacteria. The aerobic process lowers the wastewater’s organic content from about 1,000 to less than 150 parts per million."
	},
	{
		"title":"Microfiltration",
		"icon":"microfiltration",
		"linkX":652,
		"linkY":1015,
		"level":3,
		"text":"Using reverse osmosis membrane filtration, almost all of the remaining organics are removed."
	},
	{
		"title":"Irrigation Grade Water",
		"icon":"water",
		"linkX":652,
		"linkY":1215,
		"level":3,
		"text":"The water that emerges after the reclamation process is fit for irrigation and industrial usage. We use it to keep our equipment clean, cool down exothermic steps in production, and to water the lands around our headquarters."
	},
	{
		"title":"Service Electricity",
		"icon":"electricity",
		"linkX":810,
		"linkY":932,
		"level":3,
		"text":"Before the steam from our boilers reaches the distillation columns, we pass it through a turbo-generator that creates a significant amount of electricity. We put this power to use in the distillery, which reduces the amount we need to purchase."
	}
]


var sustainGraphic = function(){
	var g = $('#infoGraphic');
	var gw = g.width();
	var gh = g.height();
	var th = $('#textHolder');
	var thw = th.width();
	var thh = th.height();
	var infoDiv = $(th.find('#info'));
	var curInd = 0;
	var prevLevel = 1;
	var isInit = false;
	
	var rp = $('<div id="raphHolder" />');
	rp.height(gh);
	rp.width(gw);
	g.append(rp);
	var paper = Raphael(document.getElementById('raphHolder'), gw, gh);
	
	var init = function(){
		//hide the text holder
		th.hide();
		
		//place the marker links
		for(i=0;i<info.length;i++){
			var obj = info[i];
			placeMarker(obj.linkX, obj.linkY, i);
		}
		
		//and click handlers to the pagination links
		th.find('a[href=#next]').bind('click', function(){ 
			if(curInd < info.length -1){
				showInfo(curInd +1);
			}
			return false;
		});
		th.find('a[href=#prev]').bind('click', function(){
			if(curInd > 0){
				showInfo(curInd -1);
			}
			return false;
		});
		showInfo(0);
		isInit = true;
	}
	
	var placeMarker = function(x,y,ind){
		var m = $('<a href="#" class="marker" id="m_'+ind+'">+</a>');
		m.css({left:x, top:y}).bind('click', function(){ showInfo(ind); return false; }).bind('click',function(){return false;});
		g.append(m);
	}
	
	var drawLine = function(x, y, ind){
		paper.clear();
		var tPos = th.position();
		var hPos = th.find('h6').position().top + th.find('h6').height() + 30;
		var startY = Math.round(tPos.top + hPos);
		var startX = Math.round(tPos.left + 15);
		var p2;
		var p3;
		var p4;
		var start = startX + ' ' + startY;
		
		//this is to keep the lines from being fuzzy
		y += .5;
		x += .5;
		
		//special cases get special paths
		if(ind == 0 || ind == 7){
			x +=8;
			p3 = x + ' '+ startY;
		}else if(ind == 6){
			p2 = x+50+ ' '+ startY;
			p3 = x+50 + ' ' + y;
		}else{
			p2 = x-70+ ' '+ startY;
			p3 = x-70 + ' ' + y;
		}
		var finish = x + ' ' + y;
		
		var ps = 'M';
		ps += start;
		ps += 'L' + p2;
		ps += 'L' + p3;
		ps += 'L' + p4;
		ps += 'L' + finish;
		
		var l = paper.path('M'+start);		
		l.attr({
			'stroke':'#f8f3e5',
			"stroke-dasharray": "-",
			"stroke-opacity":.3
		});
		
		var animDur = 175;
		
		l.animate({path:'M'+start+'L'+p2}, animDur, function(){
			l.animate({path:'M'+start+'L'+ p2+'L'+p3}, animDur, function(){
				l.animate({path:ps}, animDur);
			});
		});
	}
	
	var showInfo = function(ind){
		var obj = info[ind];
		var thisM = $('#m_' + ind);
		var tp = thisM.position();
		var pls = $(th.find('.pageLinks'));
		
		//highlight the marker
		thisM.addClass('selected');
		g.find('.marker').not(thisM).removeClass('selected');
		// g.find('.marker').not(thisM).find('.on').fadeOut();
		// thisM.find('.on').fadeIn();
		
		//create the info as a string
		var infoString = '<img src="/assets/general/images/icon_'+obj.icon+'.png"/>';
		infoString += '<h6>'+obj.title+'</h6>';
		infoString += '<p>'+obj.text+'</p>';
		
		//empty the current info and put this info in there
		infoDiv.empty().append(infoString);
		
		//update the current index for pagination
		curInd = ind;
						
		//show the textholder, if it's hidden
		if(!th.is(":visible")){
			th.show();
		}
		//check the marker position and scroll the window, if necessary
		var topPad;
		switch(obj.level){
			case 1:
			topPad = 0;
			break;
			
			case 2:
			topPad = 190;
			break;
			
			case 3:
			topPad = 600;
			break;
		}
		
		pls.css({marginTop:topPad + 'px'});
		if(isInit == true){
			var target = pls.offset().top - 300;
			$.scrollTo(target, {duration:700});
		}	
		prevLevel = obj.level;
		
		//draw the line
		drawLine(tp.left, tp.top + (thisM.height()/2), ind);
	}
	
	//init!
	init();
}
*/